/**
  * LumiCine® / CinePocket 4K Christmas Edition
  * Interactive Bundle Offer Selector, 100" Screen Order Bump, Real-Time Cart Sync, Urgency Timers & Sliders
  */

document.addEventListener('DOMContentLoaded', () => {
  initBundleSelector();
  initOrderBumpSync();
  initDeliveryTimeline();
  initPetMemoriesCartDrawer();
  initPetMemoriesCheckoutModal();
  initUrgencyTimers();
  initAccordions();
  initGalleryThumbs();
  initHeaderAnnouncementSlider();
  initReviewSnippetSlider();
  initUgcAutoSlider();
  initVideoPlayerControls();
  initReviewSubmissionAndModal();
  initPolicyModal();
  loadPersistedReviews();
  syncInitialCartState();
});

// Helper to activate bundle card, sync showcase prices and dynamically update the button price
function updateActiveBundleCard(card) {
  if (!card) return;
  const bundleCards = document.querySelectorAll('.pm-bundle-card');
  bundleCards.forEach(c => c.classList.remove('active'));
  card.classList.add('active');

  const rawBasePrice = parseFloat(card.getAttribute('data-raw-price')) || 54.99;
  const qty = parseInt(card.getAttribute('data-quantity') || '1', 10);
  const oldPriceEl = card.querySelector('.pm-bundle-price-old');
  const oldPrice = oldPriceEl ? oldPriceEl.textContent.trim() : '';

  const orderBumpCheckbox = document.getElementById('pmScreenOrderBump');
  const complementaryCard = document.getElementById('pmComplementaryScreenCard');

  let finalPrice = rawBasePrice;
  if (orderBumpCheckbox && orderBumpCheckbox.checked) {
    finalPrice += 9.99;
    if (complementaryCard) complementaryCard.classList.add('pm-addon-active');
  } else {
    if (complementaryCard) complementaryCard.classList.remove('pm-addon-active');
  }

  const formattedBase = rawBasePrice.toFixed(2).replace('.', ',') + ' €';
  const formattedButton = finalPrice.toFixed(2).replace('.', ',') + ' €';

  const displayPrice = document.getElementById('pmDisplayPrice');
  const displayOldPrice = document.getElementById('pmDisplayOldPrice');
  if (displayPrice) displayPrice.textContent = formattedBase;
  if (displayOldPrice && oldPrice) displayOldPrice.textContent = oldPrice;

  // Dynamically update the Add to Cart button price in current DOM
  const ctaBtn = document.getElementById('pmAddToCartBtn');
  if (ctaBtn) {
    const ctaBtnPrice = ctaBtn.querySelector('#pmCtaBtnPrice');
    if (ctaBtnPrice) {
      ctaBtnPrice.textContent = formattedButton;
    } else {
      ctaBtn.innerHTML = `<span>🛒 AGREGAR AL CARRITO • <strong id="pmCtaBtnPrice">${formattedButton}</strong></span>`;
    }
  }

  // Update hidden inputs for Shopify forms
  const qtyInput = document.getElementById('pmProductQuantity');
  if (qtyInput) qtyInput.value = qty;
  const basePriceInput = document.getElementById('pmProductBasePrice');
  if (basePriceInput) basePriceInput.value = finalPrice;
}

// Complementary screen add-on sync
function initOrderBumpSync() {
  const bumpCheckbox = document.getElementById('pmScreenOrderBump');
  if (bumpCheckbox) {
    bumpCheckbox.addEventListener('change', () => {
      const activeCard = document.querySelector('.pm-bundle-card.active') || document.querySelector('.pm-bundle-card');
      if (activeCard) {
        updateActiveBundleCard(activeCard);
      }
    });
  }
}

// 1. Bundle Selection & Add to Cart
function initBundleSelector() {
  const bundleCards = document.querySelectorAll('.pm-bundle-card');
  const ctaButton = document.getElementById('pmAddToCartBtn');

  bundleCards.forEach(card => {
    card.addEventListener('click', () => {
      updateActiveBundleCard(card);
    });
  });

  // Ensure initial active card price is applied immediately on load
  const initialActive = document.querySelector('.pm-bundle-card.active') || bundleCards[0];
  if (initialActive) {
    updateActiveBundleCard(initialActive);
  }

  if (ctaButton) {
    ctaButton.addEventListener('click', async (e) => {
      e.preventDefault();

      const activeCard = document.querySelector('.pm-bundle-card.active') || bundleCards[0];
      if (!activeCard) return;

      const qty = parseInt(activeCard.getAttribute('data-quantity') || '1', 10);
      const rawBasePrice = parseFloat(activeCard.getAttribute('data-raw-price')) || 54.99;
      const savings = parseFloat(activeCard.getAttribute('data-savings')) || 55.00;
      const title = activeCard.querySelector('h4') ? activeCard.querySelector('h4').textContent.trim() : `Pack ${qty} Proyector 4K`;
      const orderBumpCheckbox = document.getElementById('pmScreenOrderBump');
      const screenAddedViaBump = (orderBumpCheckbox && orderBumpCheckbox.checked);

      let finalPrice = rawBasePrice;
      if (screenAddedViaBump) {
        finalPrice += 9.99;
      }
      const priceFormatted = finalPrice.toFixed(2).replace('.', ',') + ' €';

      // Button Feedback animation
      ctaButton.innerHTML = '<span>🎬 ¡Añadido al carrito navideño!</span>';
      ctaButton.style.opacity = '0.9';

      setTimeout(() => {
        const curCard = document.querySelector('.pm-bundle-card.active') || activeCard;
        updateActiveBundleCard(curCard);
        ctaButton.style.opacity = '1';
      }, 1200);

      // 1. Add the chosen Projector Bundle
      addItemToPetMemoriesCart({
        title: 'Mini Proyector Inteligente 4K (Edición Navidad)',
        bundleName: title,
        quantity: qty,
        price: rawBasePrice,
        priceFormatted: rawBasePrice.toFixed(2).replace('.', ',') + ' €',
        savings: savings,
        hasScreen: false,
        image: 'projector-christmas-hero.jpg'
      });

      // 2. If complementary screen is checked, add as its own separate product!
      if (screenAddedViaBump) {
        addItemToPetMemoriesCart({
          title: 'Pantalla de Proyección HD 100" Anti-Luz',
          bundleName: 'Añadido Complementario (100" Anti-Luz)',
          quantity: 1,
          price: 9.99,
          priceFormatted: '9,99 €',
          savings: 20.00,
          hasScreen: true,
          image: 'projector-christmas-screen.jpg'
        });
      }

      // Open Cart Drawer
      openPetMemoriesCartDrawer();
    });
  }
}

// 1.2 Dynamic Delivery Timeline calculation in Spanish
function initDeliveryTimeline() {
  const confirmEl = document.getElementById('pmTimelineConfirm');
  const shipEl = document.getElementById('pmTimelineShip');
  const deliverEl = document.getElementById('pmTimelineDeliver');

  if (!confirmEl && !shipEl && !deliverEl) return;

  const monthAbbr = [
    'ene', 'feb', 'mar', 'abr', 'may', 'jun',
    'jul', 'ago', 'sep', 'oct', 'nov', 'dic'
  ];
  const dayAbbr = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];

  const now = new Date();

  function addDays(d, days) {
    const res = new Date(d);
    res.setDate(res.getDate() + days);
    return res;
  }

  const dConfirm = addDays(now, 1);
  const dShip = addDays(now, 2);
  const dDeliverMin = addDays(now, 3);
  const dDeliverMax = addDays(now, 4);

  const confirmHtml = `Mañana <small class="pm-date-sub">(${dConfirm.getDate()} ${monthAbbr[dConfirm.getMonth()]})</small>`;
  const shipHtml = `${dayAbbr[dShip.getDay()]}, ${dShip.getDate()} ${monthAbbr[dShip.getMonth()]}`;
  const deliverHtml = `${dDeliverMin.getDate()}-${dDeliverMax.getDate()} ${monthAbbr[dDeliverMax.getMonth()]}`;

  if (confirmEl) confirmEl.innerHTML = confirmHtml;
  if (shipEl) shipEl.innerHTML = shipHtml;
  if (deliverEl) deliverEl.innerHTML = deliverHtml;
}

// 2. Cart Drawer & Checkout Handlers
function initPetMemoriesCartDrawer() {
  const overlay = document.getElementById('pmCartDrawerOverlay');
  const closeBtn = document.getElementById('pmCartDrawerClose');
  const checkoutBtn = document.getElementById('pmCartCheckoutBtn');
  const noProductModal = document.getElementById('pmNoProductModal');
  const closeNoProductBtn = document.getElementById('pmCloseNoProductModal');

  if (closeBtn) closeBtn.addEventListener('click', closePetMemoriesCartDrawer);
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closePetMemoriesCartDrawer();
    });
  }

  if (closeNoProductBtn) closeNoProductBtn.addEventListener('click', closeNoProductModal);
  if (noProductModal) {
    noProductModal.addEventListener('click', (e) => {
      if (e.target === noProductModal) closeNoProductModal();
    });
  }

  const cartTriggerSelectors = [
    'a[href="/cart"]',
    'a[href*="/cart"]',
    '.cart-link',
    '.header__icon--cart',
    '.header-cart',
    '.action__cart',
    '[data-testid="cart-drawer-trigger"]',
    '[data-cart-drawer-trigger]',
    'cart-icon',
    '[aria-controls="cart-drawer"]'
  ];

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest(cartTriggerSelectors.join(', '));
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }
      openPetMemoriesCartDrawer();
    }
  }, true);

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closePetMemoriesCartDrawer();
      openPetMemoriesCheckoutModal();
    });
  }

  renderCartDrawer();
}

async function resolveShopifyVariantsList() {
  const variantsScript = document.getElementById('pmProductVariantsData');
  if (variantsScript) {
    try {
      const variants = JSON.parse(variantsScript.textContent);
      if (variants && variants.length > 0) return variants;
    } catch (e) {}
  }

  try {
    const res = await fetch('/products.json?limit=5');
    if (res.ok) {
      const data = await res.json();
      if (data.products && data.products.length > 0) {
        return data.products[0].variants || [];
      }
    }
  } catch (err) {
    console.warn('Error fetching variants list:', err);
  }

  return [];
}

async function resolveShopifyVariantId() {
  const idEl = document.getElementById('pmProductVariantId');
  if (idEl && idEl.value && idEl.value !== '0' && idEl.value !== 'null' && idEl.value !== '') {
    return idEl.value;
  }

  const variants = await resolveShopifyVariantsList();
  if (variants && variants.length > 0) {
    const vId = String(variants[0].id);
    if (idEl) idEl.value = vId;
    return vId;
  }

  return null;
}

async function resolveShopifyVariantForPack(packQty, price) {
  const variants = await resolveShopifyVariantsList();
  if (!variants || variants.length === 0) return null;

  // Search by exact price match
  const priceInCents = Math.round(price * 100);
  const byPrice = variants.find(v => Math.abs(parseInt(v.price, 10) - priceInCents) <= 50);
  if (byPrice) return { id: byPrice.id, isPackVariant: true };

  return { id: variants[0].id, isPackVariant: false };
}

function openNoProductModal() {
  const modal = document.getElementById('pmNoProductModal');
  if (modal) {
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
}

function closeNoProductModal() {
  const modal = document.getElementById('pmNoProductModal');
  if (modal) {
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
}

function getPetMemoriesCart() {
  try {
    return JSON.parse(localStorage.getItem('pm_cart_state') || '[]');
  } catch (e) {
    return [];
  }
}

let isSyncingShopify = false;
let pendingShopifySync = null;

async function syncCartWithShopify(cart) {
  if (isSyncingShopify) {
    pendingShopifySync = cart;
    return;
  }
  isSyncingShopify = true;

  try {
    const itemsToAdd = [];
    for (const item of cart) {
      const vInfo = await resolveShopifyVariantForPack(item.quantity, item.price);
      const vId = vInfo ? vInfo.id : await resolveShopifyVariantId();
      if (vId) {
        itemsToAdd.push({
          id: vId,
          quantity: (vInfo && vInfo.isPackVariant) ? (item.count || 1) : (item.quantity * (item.count || 1)),
          properties: {
            'Pack': item.bundleName || 'Proyector Inteligente 4K',
            'Pantalla 100': item.hasScreen ? 'Sí (100" Anti-Luz)' : 'No'
          }
        });
      }
    }

    await fetch('/cart/clear.js', { method: 'POST' });
    if (itemsToAdd.length > 0) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      });
    }

    const res = await fetch('/cart.js');
    if (res.ok) {
      const shopifyCart = await res.json();
      updateHeaderCartBadges(shopifyCart.item_count);
    }
  } catch (err) {
    console.warn('Sync to Shopify native cart error:', err);
    const localTotalCount = cart.reduce((sum, it) => sum + (it.count || 1), 0);
    updateHeaderCartBadges(localTotalCount);
  } finally {
    isSyncingShopify = false;
    if (pendingShopifySync) {
      const nextCart = pendingShopifySync;
      pendingShopifySync = null;
      syncCartWithShopify(nextCart);
    }
  }
}

async function syncInitialCartState() {
  try {
    const res = await fetch('/cart.js');
    if (res.ok) {
      const nativeCart = await res.json();
      const localCart = getPetMemoriesCart();

      if (nativeCart.item_count > 0 && localCart.length === 0) {
        const reconstructed = [];
        nativeCart.items.forEach(item => {
          reconstructed.push({
            title: item.product_title || 'Mini Proyector Inteligente 4K',
            bundleName: item.properties?.Pack || item.variant_title || '1x Proyector Inteligente 4K',
            quantity: 1,
            price: item.price / 100,
            priceFormatted: (item.price / 100).toFixed(2).replace('.', ',') + ' €',
            savings: 55.00,
            hasScreen: (item.properties?.['Pantalla 100'] || '').includes('Sí'),
            count: item.quantity || 1,
            image: 'projector-christmas-hero.jpg'
          });
        });
        if (reconstructed.length > 0) {
          savePetMemoriesCart(reconstructed, false);
        }
      }

      const totalItems = nativeCart.item_count || (localCart.reduce((sum, it) => sum + (it.count || 1), 0));
      updateHeaderCartBadges(totalItems);
    }
  } catch (err) {
    console.warn('Initial cart sync error:', err);
    const localCart = getPetMemoriesCart();
    const totalItems = localCart.reduce((sum, it) => sum + (it.count || 1), 0);
    updateHeaderCartBadges(totalItems);
  }
}

function savePetMemoriesCart(cart, syncNative = true) {
  try {
    localStorage.setItem('pm_cart_state', JSON.stringify(cart));
  } catch (e) {
    console.warn('Cart storage error:', e);
  }
  renderCartDrawer();
  if (syncNative) {
    syncCartWithShopify(cart);
  }
}

function addItemToPetMemoriesCart(newItem) {
  const cart = getPetMemoriesCart();
  
  const existingItem = cart.find(it => 
    it.bundleName === newItem.bundleName &&
    Math.abs(it.price - newItem.price) < 0.05
  );

  if (existingItem) {
    existingItem.count = (existingItem.count || 1) + 1;
  } else {
    newItem.count = 1;
    cart.push(newItem);
  }

  savePetMemoriesCart(cart, true);
}

function addScreenUpsellToCart() {
  addItemToPetMemoriesCart({
    title: 'Pantalla de Proyección HD 100" Anti-Luz',
    bundleName: 'Pantalla 100" Anti-Luz (Especial Navidad)',
    quantity: 1,
    price: 9.99,
    priceFormatted: '9,99 €',
    savings: 20.00,
    hasScreen: true,
    image: 'projector-christmas-screen.jpg'
  });
}

function openPetMemoriesCartDrawer() {
  if (typeof resetPetMemoriesCheckoutButton === 'function') {
    resetPetMemoriesCheckoutButton();
  }
  const overlay = document.getElementById('pmCartDrawerOverlay');
  if (overlay) {
    overlay.style.display = 'flex';
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    renderCartDrawer();
  }
}

function closePetMemoriesCartDrawer() {
  const overlay = document.getElementById('pmCartDrawerOverlay');
  if (overlay) {
    overlay.style.display = 'none';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
}

function updateCartItemQty(index, change) {
  const cart = getPetMemoriesCart();
  if (!cart[index]) return;

  cart[index].count = (cart[index].count || 1) + change;
  if (cart[index].count <= 0) {
    cart.splice(index, 1);
  }
  savePetMemoriesCart(cart, true);
}

function removeCartItem(index) {
  const cart = getPetMemoriesCart();
  if (index >= 0 && index < cart.length) {
    cart.splice(index, 1);
    savePetMemoriesCart(cart, true);
  }
}

function renderCartDrawer() {
  const cart = getPetMemoriesCart();
  const container = document.getElementById('pmCartItemsList');
  const headerCount = document.getElementById('pmCartHeaderCount');
  const subtotalVal = document.getElementById('pmCartSubtotalVal');
  const savingsVal = document.getElementById('pmCartSavingsVal');
  const totalVal = document.getElementById('pmCartTotalVal');
  const btnPrice = document.getElementById('pmCartBtnPrice');

  if (!container) return;

  let totalItemsCount = 0;
  let totalPrice = 0;
  let totalSavings = 0;
  let hasAnyScreenInCart = false;

  cart.forEach(item => {
    const count = item.count || 1;
    totalItemsCount += count;
    totalPrice += item.price * count;
    totalSavings += (item.savings || 55.0) * count;
    if (item.hasScreen) hasAnyScreenInCart = true;
  });

  if (cart.length === 0) {
    container.innerHTML = `
      <div class="pm-cart-empty-state">
        <span class="pm-cart-empty-icon">🎬</span>
        <h4>Tu carrito navideño está vacío</h4>
        <p>Añade tu Proyector 4K para no perder la oferta especial con -50% de descuento.</p>
        <button type="button" class="pm-cart-empty-btn" onclick="closePetMemoriesCartDrawer()">Ver Ofertas Navideñas</button>
      </div>
    `;
    if (headerCount) headerCount.textContent = '0';
    if (subtotalVal) subtotalVal.textContent = '0,00 €';
    if (savingsVal) savingsVal.textContent = '0,00 €';
    if (totalVal) totalVal.textContent = '0,00 €';
    if (btnPrice) btnPrice.textContent = '0,00 €';
    updateHeaderCartBadges(0);
    return;
  }

  if (headerCount) headerCount.textContent = totalItemsCount.toString();
  updateHeaderCartBadges(totalItemsCount);

  let html = '';
  cart.forEach((item, idx) => {
    const itemTotal = (item.price * (item.count || 1)).toFixed(2).replace('.', ',');
    let itemImgSrc = item.image || 'projector-christmas-hero.jpg';
    if (!itemImgSrc.startsWith('http') && !itemImgSrc.startsWith('//') && !itemImgSrc.startsWith('/')) {
      itemImgSrc = `/assets/${itemImgSrc}`;
    }

    html += `
      <div class="pm-cart-item-card">
        <div class="pm-cart-item-img">
          <img src="${itemImgSrc}" alt="${escapeHtml(item.title)}" width="80" height="80" style="object-fit: cover; border-radius: 8px;">
        </div>
        <div class="pm-cart-item-info">
          <div class="pm-cart-item-title-row">
            <h5 class="pm-cart-item-title">${escapeHtml(item.title)}</h5>
            <button type="button" class="pm-cart-item-remove" onclick="removeCartItem(${idx})" title="Eliminar">🗑️</button>
          </div>
          <span class="pm-cart-item-pack">${escapeHtml(item.bundleName)}</span>
          <div class="pm-cart-item-bottom">
            <div class="pm-cart-qty-picker">
              <button type="button" class="pm-cart-qty-btn" onclick="updateCartItemQty(${idx}, -1)">-</button>
              <span class="pm-cart-qty-num">${item.count || 1}</span>
              <button type="button" class="pm-cart-qty-btn" onclick="updateCartItemQty(${idx}, 1)">+</button>
            </div>
            <div class="pm-cart-item-price-wrap">
              <span class="pm-cart-item-price">${itemTotal} €</span>
            </div>
          </div>
        </div>
      </div>
    `;
  });

  // Upsell Card inside drawer for the 100" screen if not added yet
  if (!hasAnyScreenInCart) {
    html += `
      <div class="pm-cart-upsell-box" style="margin-top: 14px; background: #FFF8E7; border: 1.5px dashed #D4A373; border-radius: 10px; padding: 12px; display: flex; align-items: center; justify-content: space-between; gap: 10px;">
        <div style="display: flex; align-items: center; gap: 10px;">
          <span style="font-size: 22px;">🎄</span>
          <div>
            <strong style="display: block; font-size: 13px; color: #2B2118;">¿Añadir Pantalla 100" Anti-Luz?</strong>
            <span style="font-size: 12px; color: #665c54;">Mejora el contraste en tu salón por solo <strong>+9,99 €</strong></span>
          </div>
        </div>
        <button type="button" onclick="addScreenUpsellToCart()" style="background: #134E3F; color: #FFF; border: none; padding: 8px 12px; border-radius: 6px; font-weight: 700; font-size: 12px; cursor: pointer; white-space: nowrap;">+ Añadir</button>
      </div>
    `;
  }

  container.innerHTML = html;

  const formattedTotal = totalPrice.toFixed(2).replace('.', ',') + ' €';
  const formattedSavings = totalSavings.toFixed(2).replace('.', ',') + ' €';

  if (subtotalVal) subtotalVal.textContent = formattedTotal;
  if (savingsVal) savingsVal.textContent = `-${formattedSavings} (Ahorro Total)`;
  if (totalVal) totalVal.textContent = formattedTotal;
  if (btnPrice) btnPrice.textContent = formattedTotal;

  // Free shipping bar is active for >= 50 €
  const isFreeShipping = totalPrice >= 50.0;
  const shippingText = document.getElementById('pmCartShippingText');
  const shippingFill = document.getElementById('pmCartShippingFill');
  const giftShippingRow = document.getElementById('pmCartGiftShippingRow');
  const shippingVal = document.getElementById('pmCartShippingVal');

  if (isFreeShipping) {
    if (shippingText) {
      shippingText.innerHTML = '<span>🎉 ¡Felicidades! Tienes <strong>ENVÍO EXPRÉS GRATIS CON SEGURO INCLUIDO</strong></span>';
    }
    if (shippingFill) {
      shippingFill.style.width = '100%';
      shippingFill.style.background = '#134E3F';
    }
    if (giftShippingRow) {
      giftShippingRow.style.display = 'flex';
    }
    if (shippingVal) {
      shippingVal.innerHTML = '<span class="pm-cart-free-badge">GRATIS</span>';
    }
  } else {
    const diff = (50.0 - totalPrice).toFixed(2).replace('.', ',');
    const progressPercent = Math.min(Math.max((totalPrice / 50.0) * 100, 10), 99);
    if (shippingText) {
      shippingText.innerHTML = `<span>🚚 Te faltan <strong>${diff} €</strong> para <strong>ENVÍO GRATIS Express</strong></span>`;
    }
    if (shippingFill) {
      shippingFill.style.width = `${progressPercent}%`;
      shippingFill.style.background = '#9B1B30';
    }
    if (giftShippingRow) {
      giftShippingRow.style.display = 'none';
    }
    if (shippingVal) {
      shippingVal.innerHTML = '<span style="color: #665c54; font-size: 13px;">Calculado al pagar</span>';
    }
  }
}

function updateHeaderCartBadges(count) {
  const numCount = parseInt(count, 10) || 0;
  const countStr = numCount > 0 ? (numCount < 100 ? String(numCount) : '99+') : '';

  const cartIconComponents = document.querySelectorAll('cart-icon');
  cartIconComponents.forEach(cartIcon => {
    if (typeof cartIcon.renderCartBubble === 'function') {
      try {
        cartIcon.renderCartBubble(numCount, true);
      } catch (e) {}
    }
    cartIcon.classList.toggle('header-actions__cart-icon--has-cart', numCount > 0);
  });

  document.querySelectorAll('[ref="cartBubble"], .cart-bubble').forEach(bubble => {
    bubble.classList.toggle('visually-hidden', numCount === 0);
    if (numCount > 0) {
      bubble.style.display = 'flex';
      bubble.style.opacity = '1';
      bubble.style.visibility = 'visible';
    } else {
      bubble.style.display = '';
    }
  });

  document.querySelectorAll('[ref="cartBubbleCount"], .cart-bubble__text-count, [data-testid="cart-bubble"]').forEach(countEl => {
    countEl.classList.toggle('hidden', numCount === 0);
    countEl.textContent = countStr;
    if (numCount > 0) {
      countEl.style.display = 'inline-block';
      countEl.style.visibility = 'visible';
    } else {
      countEl.style.display = '';
    }
  });

  document.querySelectorAll('.cart-count-bubble, .header__icon--cart span, #pmHeaderCartCount, [data-cart-count]').forEach(badge => {
    badge.textContent = numCount > 0 ? String(numCount) : '';
    badge.style.display = numCount > 0 ? 'inline-flex' : 'none';
  });

  try {
    sessionStorage.setItem('cart-count', JSON.stringify({
      value: countStr,
      timestamp: Date.now()
    }));
  } catch (e) {}

  try {
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { itemCount: numCount }
    }));
  } catch (e) {}
}

// 3. Urgency Timers & Live Viewers
function initUrgencyTimers() {
  const countdownEl = document.getElementById('pmCountdownDisplay');
  let secondsRemaining = 14 * 60 + 28;

  if (countdownEl) {
    setInterval(() => {
      if (secondsRemaining <= 0) {
        secondsRemaining = 15 * 60;
      }
      secondsRemaining--;
      const mins = Math.floor(secondsRemaining / 60);
      const secs = secondsRemaining % 60;
      countdownEl.textContent = `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')} min`;
    }, 1000);
  }

  const cartTimerEl = document.getElementById('pmCartTimerDigits');
  let cartSeconds = 10 * 60;
  if (cartTimerEl) {
    setInterval(() => {
      if (cartSeconds <= 0) cartSeconds = 10 * 60;
      cartSeconds--;
      const mins = Math.floor(cartSeconds / 60);
      const secs = cartSeconds % 60;
      cartTimerEl.textContent = `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }, 1000);
  }

  const viewersEl = document.getElementById('pmLiveViewers');
  if (viewersEl) {
    setInterval(() => {
      const randomViewers = Math.floor(Math.random() * (64 - 45 + 1)) + 45;
      viewersEl.textContent = randomViewers.toString();
    }, 6000);
  }
}

// 4. Feature Card Slider
function initUgcAutoSlider() {
  const track = document.getElementById('pmUgcTrack');
  const cards = document.querySelectorAll('.pm-ugc-card');
  const dots = document.querySelectorAll('.pm-ugc-dot');

  if (!track || cards.length <= 1) return;

  let currentUgcIndex = 0;
  let ugcTimer = null;

  function updateUgcSlider(index) {
    currentUgcIndex = index % cards.length;
    const step = cards.length > 1 ? (cards[1].offsetLeft - cards[0].offsetLeft) : (cards[0].offsetWidth + 16);
    track.style.transition = 'transform 0.6s cubic-bezier(0.25, 1, 0.5, 1)';
    track.style.transform = `translateX(-${currentUgcIndex * step}px)`;

    dots.forEach((dot, idx) => {
      dot.classList.toggle('active', idx === currentUgcIndex);
    });
  }

  function startUgcTimer() {
    stopUgcTimer();
    ugcTimer = setInterval(() => {
      const isMobile = window.innerWidth < 640;
      const isTablet = window.innerWidth < 900;
      const maxIndex = isMobile ? cards.length - 1 : (isTablet ? cards.length - 2 : cards.length - 3);
      let nextIndex = currentUgcIndex + 1;
      if (nextIndex > (maxIndex > 0 ? maxIndex : cards.length - 1)) {
        nextIndex = 0;
      }
      updateUgcSlider(nextIndex);
    }, 3500);
  }

  function stopUgcTimer() {
    if (ugcTimer) clearInterval(ugcTimer);
  }

  dots.forEach((dot, idx) => {
    dot.addEventListener('click', () => {
      updateUgcSlider(idx);
      startUgcTimer();
    });
  });

  const container = track.closest('.pm-ugc-slider-container');
  if (container) {
    container.addEventListener('mouseenter', stopUgcTimer);
    container.addEventListener('mouseleave', startUgcTimer);
  }

  window.addEventListener('resize', () => {
    updateUgcSlider(currentUgcIndex);
  });

  startUgcTimer();
}

function initVideoPlayerControls() {}

// 6. Accordions & Gallery Thumbs
function initAccordions() {
  const trustTriggers = document.querySelectorAll('.pm-trust-trigger');
  trustTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.pm-trust-item');
      if (item) {
        const isOpen = item.classList.contains('open');
        document.querySelectorAll('.pm-trust-item').forEach(i => i.classList.remove('open'));
        if (!isOpen) item.classList.add('open');
      }
    });
  });

  const faqHeaders = document.querySelectorAll('.pm-faq-header');
  faqHeaders.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.pm-faq-item');
      if (item) {
        item.classList.toggle('open');
      }
    });
  });
}

function initGalleryThumbs() {
  const thumbs = document.querySelectorAll('.pm-thumb');
  const mainImg = document.getElementById('pmMainProductImg');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const targetSrc = thumb.getAttribute('data-full-img');
      if (mainImg && targetSrc) {
        mainImg.src = targetSrc;
      }
    });
  });
}

function initReviewSnippetSlider() {
  const track = document.getElementById('pmReviewSliderTrack');
  const slides = document.querySelectorAll('.pm-review-slide-item');
  const dots = document.querySelectorAll('.pm-review-dot');

  if (!track || slides.length <= 1) return;

  let currentSlide = 0;
  let autoTimer = null;

  function goToSlide(index) {
    currentSlide = (index + slides.length) % slides.length;
    track.style.transition = 'transform 0.5s cubic-bezier(0.25, 1, 0.5, 1)';
    track.style.transform = `translateX(-${currentSlide * 100}%)`;

    dots.forEach((dot, idx) => {
      dot.classList.toggle('active', idx === currentSlide);
    });
  }

  function startTimer() {
    stopTimer();
    autoTimer = setInterval(() => {
      goToSlide(currentSlide + 1);
    }, 4200);
  }

  function stopTimer() {
    if (autoTimer) clearInterval(autoTimer);
  }

  dots.forEach((dot, idx) => {
    dot.addEventListener('click', () => {
      goToSlide(idx);
      startTimer();
    });
  });

  const wrapper = track.closest('.pm-review-slider-wrapper');
  if (wrapper) {
    wrapper.addEventListener('mouseenter', stopTimer);
    wrapper.addEventListener('mouseleave', startTimer);
  }

  startTimer();
}

// 7. Interactive Reviews Modal
function initReviewSubmissionAndModal() {
  const openBtn = document.getElementById('pmBtnWriteReview');
  const modalOverlay = document.getElementById('pmReviewModalOverlay');
  const closeBtn = document.getElementById('pmReviewModalClose');
  const form = document.getElementById('pmInteractiveReviewForm');
  const starBtns = document.querySelectorAll('#pmModalStarSelect .pm-star-btn');
  const ratingInput = document.getElementById('pmFormRatingInput');

  if (!modalOverlay || !form) return;

  if (openBtn) {
    openBtn.addEventListener('click', () => {
      modalOverlay.style.display = 'flex';
      modalOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  }

  function closeModal() {
    modalOverlay.style.display = 'none';
    modalOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) closeModal();
  });

  starBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const val = parseInt(btn.getAttribute('data-val'), 10);
      if (ratingInput) ratingInput.value = val;
      starBtns.forEach(b => {
        const bVal = parseInt(b.getAttribute('data-val'), 10);
        b.classList.toggle('active', bVal <= val);
      });
    });
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const name = document.getElementById('pmFormName').value.trim();
    const city = document.getElementById('pmFormCity').value.trim();
    const pack = document.getElementById('pmFormPack').value;
    const comment = document.getElementById('pmFormComment').value.trim();
    const rating = ratingInput ? parseInt(ratingInput.value, 10) : 5;

    const reviewObj = {
      author: `${name} (${city})`,
      date: 'Hoy (Reciente)',
      pack: pack,
      rating: rating,
      body: comment,
      isVerified: true
    };

    saveReviewToLocalStorage(reviewObj);
    prependReviewToDOM(reviewObj);
    incrementReviewCounts(rating);

    form.reset();
    closeModal();
    alert('¡Muchas gracias por tu valoración! Ha sido publicada correctamente.');
  });
}

function buildStarsHtml(count) {
  let stars = '';
  for (let i = 0; i < 5; i++) {
    stars += i < count ? '★' : '☆';
  }
  return stars;
}

function prependReviewToDOM(review) {
  const container = document.getElementById('pmDynamicReviewsContainer');
  if (!container) return;

  const card = document.createElement('div');
  card.className = 'pm-review-card-full pm-review-text-only pm-review-newly-added';

  card.innerHTML = `
    <div class="pm-review-full-top">
      <span class="pm-review-full-author">${escapeHtml(review.author)}</span>
      <span class="pm-review-full-date">${escapeHtml(review.date)}</span>
    </div>
    <div class="pm-review-meta-badge">
      <span class="pm-stars">${buildStarsHtml(review.rating)}</span>
      <span>✓ Comprador verificado</span>
      <span class="pm-review-breed-tag">${escapeHtml(review.pack || 'Pack Proyector')}</span>
    </div>
    <div class="pm-review-quote-mark">“</div>
    <p class="pm-review-full-body">"${escapeHtml(review.body)}"</p>
    <div class="pm-review-text-footer">
      <span class="pm-review-verified-pill">✓ Compra verificada</span>
    </div>
  `;

  container.insertBefore(card, container.firstChild);
}

function escapeHtml(string) {
  const div = document.createElement('div');
  div.textContent = string;
  return div.innerHTML;
}

function saveReviewToLocalStorage(review) {
  try {
    const existing = JSON.parse(localStorage.getItem('pm_projector_reviews') || '[]');
    existing.unshift(review);
    localStorage.setItem('pm_projector_reviews', JSON.stringify(existing));
  } catch (err) {}
}

function loadPersistedReviews() {
  try {
    const saved = JSON.parse(localStorage.getItem('pm_projector_reviews') || '[]');
    if (Array.isArray(saved) && saved.length > 0) {
      saved.reverse().forEach(rev => prependReviewToDOM(rev));
      saved.forEach(rev => incrementReviewCounts(rev.rating || 5));
    }
  } catch (err) {}
}

function incrementReviewCounts(rating) {
  const totalCountEl = document.getElementById('pmReviewsCountTotal');
  if (totalCountEl) {
    const currentTotal = parseInt(totalCountEl.textContent.trim(), 10) || 142;
    totalCountEl.textContent = (currentTotal + 1).toString();
  }

  const barCountEl = document.getElementById(`pmBarCount${rating}`);
  if (barCountEl) {
    const currentRatingCount = parseInt(barCountEl.textContent.trim(), 10) || 0;
    barCountEl.textContent = (currentRatingCount + 1).toString();
  }
}

// 8. Policy Modal
function initPolicyModal() {
  const modalOverlay = document.getElementById('pmPolicyModalOverlay');
  const closeBtn = document.getElementById('pmPolicyModalClose');
  const understoodBtn = document.getElementById('pmPolicyBtnUnderstood');
  const modalTitle = document.getElementById('pmPolicyModalTitle');
  const tabs = document.querySelectorAll('.pm-policy-tab');
  const panes = document.querySelectorAll('.pm-policy-pane');

  if (!modalOverlay) return;

  const policyTitles = {
    terms: 'Términos y Condiciones del Servicio',
    privacy: 'Política de Privacidad y Protección de Datos (RGPD)',
    shipping: 'Política de Envíos y Plazos de Entrega',
    returns: 'Política de Devoluciones y Reembolsos (30 Días)',
    legal: 'Aviso Legal (LSSI-CE)'
  };

  function switchTab(policyKey) {
    const targetKey = policyTitles[policyKey] ? policyKey : 'terms';

    tabs.forEach(tab => {
      tab.classList.toggle('active', tab.getAttribute('data-policy') === targetKey);
    });

    panes.forEach(pane => {
      pane.classList.toggle('active', pane.id === `pane-${targetKey}`);
    });

    if (modalTitle && policyTitles[targetKey]) {
      modalTitle.textContent = policyTitles[targetKey];
    }
  }

  function openPolicyModal(policyKey) {
    switchTab(policyKey);
    modalOverlay.style.display = 'flex';
    modalOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closePolicyModal() {
    modalOverlay.style.display = 'none';
    modalOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const key = tab.getAttribute('data-policy');
      switchTab(key);
    });
  });

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-open-policy], .pm-policy-link, a[href="#pmPolicyModalOverlay"]');
    if (trigger) {
      e.preventDefault();
      const policyKey = trigger.getAttribute('data-open-policy') || 'terms';
      openPolicyModal(policyKey);
    }
  });

  if (closeBtn) closeBtn.addEventListener('click', closePolicyModal);
  if (understoodBtn) understoodBtn.addEventListener('click', closePolicyModal);
  modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) closePolicyModal();
  });
}

// 9. Announcement Slider
function initHeaderAnnouncementSlider() {
  const container = document.querySelector('announcement-bar-component') || document.querySelector('.announcement-bar__slider');
  if (!container) return;

  const slides = container.querySelectorAll('.announcement-bar__slide');
  if (!slides || slides.length <= 1) return;

  let currentIndex = 0;
  let timer = null;
  const slideInterval = 3800;

  function showSlide(index) {
    currentIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      const isCurrent = i === currentIndex;
      slide.setAttribute('aria-hidden', !isCurrent);
      if (isCurrent) {
        slide.style.opacity = '1';
        slide.style.visibility = 'visible';
        slide.style.pointerEvents = 'auto';
        slide.classList.add('is-active');
      } else {
        slide.style.opacity = '0';
        slide.style.visibility = 'hidden';
        slide.style.pointerEvents = 'none';
        slide.classList.remove('is-active');
      }
    });
  }

  function nextSlide() {
    showSlide(currentIndex + 1);
  }

  function prevSlide() {
    showSlide(currentIndex - 1);
  }

  function startAutoplay() {
    stopAutoplay();
    timer = setInterval(nextSlide, slideInterval);
  }

  function stopAutoplay() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  showSlide(0);
  startAutoplay();
}

// 10. Checkout Modal
function initPetMemoriesCheckoutModal() {
  const modalOverlay = document.getElementById('pmCheckoutModalOverlay');
  const modalCloseBtn = document.getElementById('pmCheckoutModalClose');
  const backToCartBtn = document.getElementById('pmCheckoutBackToCart');
  const form = document.getElementById('pmCustomerShippingForm');

  if (modalCloseBtn) modalCloseBtn.addEventListener('click', closePetMemoriesCheckoutModal);
  if (backToCartBtn) {
    backToCartBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closePetMemoriesCheckoutModal();
      openPetMemoriesCartDrawer();
    });
  }
  if (modalOverlay) {
    modalOverlay.addEventListener('click', (e) => {
      if (e.target === modalOverlay) closePetMemoriesCheckoutModal();
    });
  }

  // Pre-populate saved customer data from localStorage
  try {
    const saved = JSON.parse(localStorage.getItem('pm_customer_data') || '{}');
    if (saved.email) {
      const el = document.getElementById('pmShipEmail');
      if (el) el.value = saved.email;
    }
    if (saved.phone) {
      const el = document.getElementById('pmShipPhone');
      if (el) el.value = saved.phone;
    }
    if (saved.firstName) {
      const el = document.getElementById('pmShipFirstName');
      if (el) el.value = saved.firstName;
    }
    if (saved.lastName) {
      const el = document.getElementById('pmShipLastName');
      if (el) el.value = saved.lastName;
    }
    if (saved.address1) {
      const el = document.getElementById('pmShipAddress1');
      if (el) el.value = saved.address1;
    }
    if (saved.zip) {
      const el = document.getElementById('pmShipZip');
      if (el) el.value = saved.zip;
    }
    if (saved.city) {
      const el = document.getElementById('pmShipCity');
      if (el) el.value = saved.city;
    }
    if (saved.province) {
      const el = document.getElementById('pmShipProvince');
      if (el) el.value = saved.province;
    }
  } catch (e) {}

  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const emailEl = document.getElementById('pmShipEmail');
      const phoneEl = document.getElementById('pmShipPhone');
      const firstNameEl = document.getElementById('pmShipFirstName');
      const lastNameEl = document.getElementById('pmShipLastName');
      const address1El = document.getElementById('pmShipAddress1');
      const zipEl = document.getElementById('pmShipZip');
      const cityEl = document.getElementById('pmShipCity');
      const provinceEl = document.getElementById('pmShipProvince');

      let isValid = true;
      const clearError = (id, el) => {
        const err = document.getElementById(id);
        if (err) err.textContent = '';
        if (el) el.classList.remove('pm-input-invalid');
      };
      const setError = (id, el, msg) => {
        const err = document.getElementById(id);
        if (err) err.textContent = msg;
        if (el) el.classList.add('pm-input-invalid');
        isValid = false;
      };

      clearError('pmErrorEmail', emailEl);
      clearError('pmErrorPhone', phoneEl);
      clearError('pmErrorFirstName', firstNameEl);
      clearError('pmErrorLastName', lastNameEl);
      clearError('pmErrorAddress1', address1El);
      clearError('pmErrorZip', zipEl);
      clearError('pmErrorCity', cityEl);
      clearError('pmErrorProvince', provinceEl);

      const emailVal = emailEl ? emailEl.value.trim() : '';
      const phoneVal = phoneEl ? phoneEl.value.trim() : '';
      const firstNameVal = firstNameEl ? firstNameEl.value.trim() : '';
      const lastNameVal = lastNameEl ? lastNameEl.value.trim() : '';
      const address1Val = address1El ? address1El.value.trim() : '';
      const zipVal = zipEl ? zipEl.value.trim() : '';
      const cityVal = cityEl ? cityEl.value.trim() : '';
      const provinceVal = provinceEl ? provinceEl.value.trim() : '';

      if (!emailVal || !emailVal.includes('@')) setError('pmErrorEmail', emailEl, 'Introduce un correo válido.');
      if (!phoneVal || phoneVal.length < 7) setError('pmErrorPhone', phoneEl, 'Introduce un teléfono de contacto.');
      if (!firstNameVal) setError('pmErrorFirstName', firstNameEl, 'Introduce tu nombre.');
      if (!lastNameVal) setError('pmErrorLastName', lastNameEl, 'Introduce tus apellidos.');
      if (!address1Val) setError('pmErrorAddress1', address1El, 'Introduce la calle, número y portal.');
      if (!zipVal || zipVal.length < 4) setError('pmErrorZip', zipEl, 'Introduce tu código postal.');
      if (!cityVal) setError('pmErrorCity', cityEl, 'Introduce tu ciudad o municipio.');
      if (!provinceVal) setError('pmErrorProvince', provinceEl, 'Selecciona tu provincia.');

      if (!isValid) return;

      // Save customer details in localStorage
      try {
        localStorage.setItem('pm_customer_data', JSON.stringify({
          email: emailVal,
          phone: phoneVal,
          firstName: firstNameVal,
          lastName: lastNameVal,
          address1: address1Val,
          zip: zipVal,
          city: cityVal,
          province: provinceVal
        }));
      } catch (err) {}

      const submitBtn = document.getElementById('pmCheckoutSubmitBtn');
      if (submitBtn) {
        submitBtn.innerHTML = '<span>⏳ Conectando con Shopify Checkout Oficial...</span>';
        submitBtn.style.opacity = '0.85';
        submitBtn.disabled = true;
      }

      // Safety fallback: if user stays on page or aborts, restore button state
      setTimeout(() => {
        resetPetMemoriesCheckoutButton();
      }, 7000);

      try {
        const localCart = getPetMemoriesCart();
        await fetch('/cart/clear.js', { method: 'POST' });

        const itemsToAdd = [];
        if (localCart.length > 0) {
          for (const item of localCart) {
            const vInfo = await resolveShopifyVariantForPack(item.quantity, item.price);
            itemsToAdd.push({
              id: vInfo ? vInfo.id : await resolveShopifyVariantId(),
              quantity: (vInfo && vInfo.isPackVariant) ? (item.count || 1) : (item.quantity * (item.count || 1)),
              properties: {
                'Pack': item.bundleName || 'Proyector Inteligente 4K',
                'Pantalla 100': item.hasScreen ? 'Sí (100" Anti-Luz)' : 'No'
              }
            });
          }
        } else {
          itemsToAdd.push({
            id: await resolveShopifyVariantId(),
            quantity: 1,
            properties: {
              'Pack': '1x Proyector Inteligente 4K'
            }
          });
        }

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        });

        const checkoutParams = new URLSearchParams();
        checkoutParams.append('checkout[email]', emailVal);
        checkoutParams.append('checkout[shipping_address][first_name]', firstNameVal);
        checkoutParams.append('checkout[shipping_address][last_name]', lastNameVal);
        checkoutParams.append('checkout[shipping_address][address1]', address1Val);
        checkoutParams.append('checkout[shipping_address][city]', cityVal);
        checkoutParams.append('checkout[shipping_address][province]', provinceVal);
        checkoutParams.append('checkout[shipping_address][zip]', zipVal);
        checkoutParams.append('checkout[shipping_address][country]', 'España');
        checkoutParams.append('checkout[shipping_address][phone]', phoneVal);

        window.location.href = `/checkout?${checkoutParams.toString()}`;
      } catch (err) {
        console.warn('Checkout redirection fallback:', err);
        resetPetMemoriesCheckoutButton();
        window.location.href = '/checkout';
      }
    });
  }

  // Ensure button is ready and enabled on initialization & back/forward navigation
  resetPetMemoriesCheckoutButton();
  window.addEventListener('pageshow', () => {
    resetPetMemoriesCheckoutButton();
  });
  window.addEventListener('focus', () => {
    resetPetMemoriesCheckoutButton();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      resetPetMemoriesCheckoutButton();
    }
  });
}

function resetPetMemoriesCheckoutButton(customTotal) {
  const submitBtn = document.getElementById('pmCheckoutSubmitBtn');
  if (!submitBtn) return;

  submitBtn.disabled = false;
  submitBtn.removeAttribute('disabled');
  submitBtn.style.opacity = '1';
  submitBtn.style.pointerEvents = 'auto';
  submitBtn.style.cursor = 'pointer';

  let displayPrice = customTotal;
  if (!displayPrice) {
    const totalVal = document.getElementById('pmCheckoutTotalVal') || document.getElementById('pmCartTotalVal');
    if (totalVal && totalVal.textContent.trim()) {
      displayPrice = totalVal.textContent.trim();
    } else {
      const cart = getPetMemoriesCart();
      if (cart.length > 0) {
        let sum = 0;
        cart.forEach(item => { sum += item.price * (item.count || 1); });
        displayPrice = sum.toFixed(2).replace('.', ',') + ' €';
      } else {
        displayPrice = '54,99 €';
      }
    }
  }

  submitBtn.innerHTML = `<span>CONTINUAR AL PAGO SEGURO • <strong id="pmCheckoutBtnTotalDisplay">${displayPrice}</strong> ➔</span>`;
}

function openPetMemoriesCheckoutModal() {
  const overlay = document.getElementById('pmCheckoutModalOverlay');
  if (!overlay) return;

  const cart = getPetMemoriesCart();
  const itemsListEl = document.getElementById('pmCheckoutSummaryItemsList');
  const subtotalVal = document.getElementById('pmCheckoutSubtotalVal');
  const shippingVal = document.getElementById('pmCheckoutShippingVal');
  const savingsVal = document.getElementById('pmCheckoutSavingsVal');
  const totalVal = document.getElementById('pmCheckoutTotalVal');

  let totalPrice = 0;
  let totalSavings = 0;

  if (cart.length > 0) {
    let rowsHtml = '';
    cart.forEach(item => {
      const count = item.count || 1;
      const itemTotalNum = item.price * count;
      totalPrice += itemTotalNum;
      totalSavings += (item.savings || 55.0) * count;

      const itemPrice = itemTotalNum.toFixed(2).replace('.', ',') + ' €';
      let itemImgSrc = item.image || 'projector-christmas-hero.jpg';
      if (!itemImgSrc.startsWith('http') && !itemImgSrc.startsWith('//') && !itemImgSrc.startsWith('/')) {
        itemImgSrc = `/assets/${itemImgSrc}`;
      }

      rowsHtml += `
        <div class="pm-summary-item-row" style="margin-bottom: 12px; padding-bottom: 12px; border-bottom: 1px dashed #E8DEC8; display: flex; align-items: center; gap: 12px;">
          <div class="pm-summary-thumb">
            <img src="${itemImgSrc}" alt="${escapeHtml(item.title)}" width="60" height="60" style="border-radius: 8px; object-fit: cover;">
          </div>
          <div class="pm-summary-details">
            <h5 style="margin: 0 0 4px 0; font-size: 14px; font-weight: 700; color: #2B2118;">${escapeHtml(item.title)} ${count > 1 ? `(x${count})` : ''}</h5>
            <span class="pm-summary-pack-badge" style="display: inline-block; background: #EAE0D5; color: #5E503F; font-size: 11px; padding: 2px 8px; border-radius: 4px; font-weight: 600;">${escapeHtml(item.bundleName)}</span>
          </div>
          <div class="pm-summary-price" style="font-weight: 800; color: #2B2118; font-size: 15px; margin-left: auto;">${itemPrice}</div>
        </div>
      `;
    });

    if (itemsListEl) itemsListEl.innerHTML = rowsHtml;
  } else {
    totalPrice = 54.99;
    totalSavings = 55.00;
  }

  const formattedTotal = totalPrice.toFixed(2).replace('.', ',') + ' €';
  const formattedSavings = totalSavings.toFixed(2).replace('.', ',') + ' €';

  if (subtotalVal) subtotalVal.textContent = formattedTotal;
  if (savingsVal) savingsVal.textContent = `-${formattedSavings} (Ahorro Total)`;
  if (totalVal) totalVal.textContent = formattedTotal;

  // Fully reset button with updated total
  resetPetMemoriesCheckoutButton(formattedTotal);

  if (shippingVal) {
    shippingVal.innerHTML = '<strong style="color: #134E3F;">GRATIS</strong>';
  }

  overlay.style.display = 'flex';
  overlay.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function closePetMemoriesCheckoutModal() {
  const overlay = document.getElementById('pmCheckoutModalOverlay');
  if (overlay) {
    overlay.style.display = 'none';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  resetPetMemoriesCheckoutButton();
}
